/**
 * Classic J: two long firefly tracks between three yards (docs/spec/03 §2). Cross at the dirt
 * level crossings between laps; every hole you make in a core is a new short cut for the fireflies.
 */

import type { CaveDef } from '../types';

export const caveJ: CaveDef = {
  id: 'J',
  name: 'RAIL YARD',
  hint: 'Mind the gap between the trains.',
  intermission: false,
  colors: [11, 3, 1],
  diamondValue: 20,
  extraValue: 35,
  fill: { base: '.', items: [['r', 6], ['d', 8]] },
  levels: [
    { seed: 2301, diamonds: 14, time: 120 },
    { seed: 2302, diamonds: 16, time: 115 },
    { seed: 2303, diamonds: 18, time: 110 },
    { seed: 2304, diamonds: 20, time: 100 },
    { seed: 2305, diamonds: 22, time: 90 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W...???????????????????????????????????W',
    'W.P.???????????????????????????????????W',
    'W...???????????????????????????????????W',
    'W????.?.??????.?.??????.?.??????.?.????W',
    'Wwwwww.wwwwwwww.wwwwwwww.wwwwwwww.wwwwwW',
    'Ww      f                     f       wW',
    'Ww www.wwwwwwww.wwwwwwww.wwwwwwww.www wW',
    'Ww                  F                 wW',
    'Wwwwww.wwwwwwww.wwwwwwww.wwwwwwww.wwwwwW',
    'W?????????????????????????dd???????????W',
    'W?????????d.d?????????????????????d????W',
    'W??.?.??????.?.??????.?.??????.?.??.?.?W',
    'Wwww.wwwwwwww.wwwwwwww.wwwwwwww.wwww.wwW',
    'Ww                                f   wW',
    'Ww w.wwwwwwww.wwwwwwww.wwwwwwww.wwww. wW',
    'Ww          F             F           wW',
    'Wwww.wwwwwwww.wwwwwwww.wwwwwwww.wwww.wwW',
    'W??????????????????????????????????????W',
    'W???????????????????????????????????X??W',
    'W??????????????????????????????????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
